import React from "react";
import Widgets from "../../../widgets";
import countryOptions from "../../../widgets/countryCodeSelect/countyOption";
import "./Alpha2CodeList.css";

const Alpha2CodeList = () => {
  return (
    <div className="nurse-container">
      <div className="department-heading">Country Codes</div>
      <div style={{ marginTop: 12 }}>
        <table className="nurse-table">
          <thead className="nurse-thead">
            <tr>
              <th>Country</th>
              <th>Alpha‑2</th>
              <th>Contact Code</th>
            </tr>
          </thead>
          <tbody className="ppl-tbody">
            {countryOptions.map((c, idx) => (
              <tr key={idx} className="ppl-table-row">
                <td>{c.label}</td>
                <td>{c.flag}</td>
                <td>{`+${c.value}`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Alpha2CodeList;